import React from 'react';
import { Link } from 'react-router-dom';
import Page from '../page';
import { shuffle } from 'lodash';
import { lookupPath, createPath, mpPartyElectorateText } from '../helpers';
import Footer from '../footer';

const Choose = ({
  electorates,
  parties,
  mps,
  title,
  lead,
  chooseStepContent,
  totalSteps,
  hideLookupStep,
  userInput: { selectedElectorateId, selectedPartyId },
  selectedParty,
  selectedElectorate,
  setUserInput,
  history
}) => {
  const mpList = shuffle(mps);
  let selectedMPs = mpList.filter(
    (mp) =>
      mp.partyId === selectedPartyId || mp.electorateId === selectedElectorateId
  );

  let message = '';
  if (selectedParty || selectedElectorate) {
    if (selectedMPs.length === 0) {
      message =
        'There were no MPs in the electorate or party you selected. Here is a list of MPs it would be good to target based on their portfolios, voting history or political positioning.';
    } else if (selectedParty && selectedElectorate) {
      message = `Based on your electorate of ${selectedElectorate.name} and vote for ${selectedParty.name} we suggest you write to:`;
    } else if (selectedParty) {
      message = `Based on your vote for ${selectedParty.name} we suggest you write to:`;
    } else {
      message = `Based on your electorate of ${selectedElectorate.name} we suggest you write to:`;
    }
  } else {
    message =
      'Here is a list of MPs it would be good to target based on their portfolios, voting history or political positioning.';
  }
  if (selectedMPs.length === 0) {
    selectedMPs = mpList;
  }
  const otherMPs = mpList.filter(
    (mp) => !selectedMPs.some((smp) => smp.id === mp.id)
  );

  const infoPanel = (
    <div dangerouslySetInnerHTML={{ __html: chooseStepContent }} />
  );

  const renderMP = (mp) => {
    const mpParty = parties.find((p) => p.id === mp.partyId);
    const mpElectorate = electorates.find((e) => e.id === mp.electorateId);

    return (
      <div key={mp.id}>
        <div className="row mb-3">
          <div className="col-sm-9 text-left">
            <img
              className="img-fluid img-thumbnail float-left mr-2"
              alt={mp.name}
              style={{ height: '60px' }}
              src={mp.imageUrl}
            />
            <p className="h5 mb-1" htmlFor={`select-${mp.id}`}>
              Email {mp.name}
            </p>
            {mpPartyElectorateText(mp, mpParty, mpElectorate)}
          </div>
          <div className="col-sm-3">
            <button
              id={`select-${mp.id}`}
              onClick={(e) => {
                setUserInput({ selectedMPId: mp.id });
                history.push(
                  createPath({
                    mp: mp.id,
                    electorate: selectedElectorateId,
                    party: selectedPartyId
                  })
                );
              }}
              className="btn btn-sm btn-block btn-outline-redpink"
            >
              Select →
            </button>
          </div>
        </div>
        <hr />
      </div>
    );
  };

  const footerLink = !hideLookupStep && (
    <Link
      to={lookupPath({
        electorate: selectedElectorateId,
        party: selectedPartyId
      })}
      className="btn btn-outline-redpink btn-block"
    >
      ← Lookup
    </Link>
  );
  const footer = (
    <Footer
      step={hideLookupStep ? 1 : 2}
      totalSteps={totalSteps}
      left={footerLink}
    />
  );

  const header = (
    <h2 className="h4 mb-0 text-uppercase text-center">
      Choose an MP to Write To
    </h2>
  );

  return (
    <Page
      title={title}
      lead={lead}
      infoPanel={infoPanel}
      header={header}
      footer={footer}
    >
      <div className="form-group">
        <label className="mb-3" htmlFor="suggested-mps">
          {message}
        </label>
        <div id="suggested-mps">{selectedMPs.map((p) => renderMP(p))}</div>
      </div>
      {otherMPs.length !== 0 && (
        <div className="form-group mt-4">
          <label className="mb-3" htmlFor="other-mps">
            You could also choose to email:
          </label>
          <div id="other-mps">{otherMPs.map((p) => renderMP(p))}</div>
        </div>
      )}
    </Page>
  );
};

export default Choose;
